"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";

const demoAccounts = [
  ["Super admin", "superadmin@nails.studio", "SuperAdmin123!"],
  ["Admin", "admin@nails.studio", "Admin123!"],
  ["Studio", "studio@nails.studio", "Studio123!"],
  ["Customer", "customer@nails.studio", "Customer123!"],
];

export function LoginForm({ showDemo }: { showDemo: boolean }) {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);

  async function onSubmit(event: React.FormEvent) {
    event.preventDefault();
    setPending(true);
    setError("");
    const response = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    const data = (await response.json().catch(() => null)) as { error?: string; user?: { role?: string } } | null;
    if (!response.ok) {
      setError(data?.error ?? "Could not sign in.");
      setPending(false);
      return;
    }
    router.push(data?.user?.role === "customer" ? "/salons" : "/dashboard");
    router.refresh();
  }

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <label className="block text-sm">
        <span className="mb-1.5 block text-muted">Email</span>
        <input
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          className="w-full rounded-xl border border-line bg-white px-3 py-2.5 outline-none focus:border-rose"
        />
      </label>
      <label className="block text-sm">
        <span className="mb-1.5 block text-muted">Password</span>
        <input
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          className="w-full rounded-xl border border-line bg-white px-3 py-2.5 outline-none focus:border-rose"
        />
      </label>
      {error ? <p className="rounded-xl bg-blush px-3 py-2 text-sm text-rose-deep">{error}</p> : null}
      <button
        type="submit"
        disabled={pending}
        className="w-full rounded-full bg-rose px-4 py-2.5 text-sm font-medium text-ink hover:bg-[#c4922e] disabled:opacity-60"
      >
        {pending ? "Signing in" : "Sign in"}
      </button>
      {showDemo ? (
        <div className="rounded-2xl border border-line bg-paper/70 p-4 text-sm">
          <p className="mb-2 font-medium">Local demo accounts</p>
          <ul className="space-y-1.5 text-muted">
            {demoAccounts.map(([label, accountEmail, accountPassword]) => (
              <li key={accountEmail}>
                <button
                  type="button"
                  className="text-left hover:text-ink"
                  onClick={() => {
                    setEmail(accountEmail);
                    setPassword(accountPassword);
                  }}
                >
                  <span className="text-ink">{label}</span> · {accountEmail}
                </button>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </form>
  );
}
